<template>
  <div class="lab-activity-page">
    <div class="page-banner">
      <h1>科创活动</h1>
      <p>汇聚创新力量，赋能科技成果转化</p>
    </div>
    <div class="main-container">
      <div class="section-card">
        <div class="section-icon training-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 6v12" /><path d="M6 12h12" />
            <rect x="3" y="3" width="18" height="18" rx="3" />
          </svg>
        </div>
        <h2>专业培训</h2>
        <p class="section-desc">提供前沿技术培训、创业辅导、知识产权等专业课程，助力科创人才成长</p>
      </div>
      <div class="section-card">
        <div class="section-icon roadshow-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="5,3 19,12 5,21" />
          </svg>
        </div>
        <h2>项目路演</h2>
        <p class="section-desc">定期举办项目路演活动，搭建投融资对接平台，促进优质项目落地</p>
      </div>
      <div class="section-card">
        <div class="section-icon salon-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 8v4l3 2" />
          </svg>
        </div>
        <h2>科创沙龙</h2>
        <p class="section-desc">打造开放式交流平台，邀请行业专家、创业者分享经验，碰撞创新火花</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabActivityView'
}
</script>

<style scoped>
.lab-activity-page {
  min-height: calc(100vh - 70px);
  background-color: #f7f8fc;
}

.page-banner {
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  color: white;
  text-align: center;
  padding: 60px 24px;
}

.page-banner h1 {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 12px;
  letter-spacing: 4px;
}

.page-banner p {
  font-size: 16px;
  opacity: 0.85;
}

.main-container {
  max-width: 1200px;
  margin: -30px auto 60px;
  padding: 0 24px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.section-card {
  background: white;
  border-radius: 12px;
  padding: 40px 28px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0,0,0,0.06);
  transition: transform 0.3s, box-shadow 0.3s;
}

.section-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(24,144,255,0.12);
}

.section-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-icon svg {
  width: 32px;
  height: 32px;
}

.training-icon {
  background: #e6f7ff;
  color: #1890ff;
}

.roadshow-icon {
  background: #fff7e6;
  color: #fa8c16;
}

.salon-icon {
  background: #f6ffed;
  color: #52c41a;
}

.section-card h2 {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 12px;
}

.section-desc {
  font-size: 14px;
  color: #8a8e99;
  line-height: 1.8;
}

@media (max-width: 1024px) {
  .main-container {
    gap: 24px;
  }
  .page-banner {
    padding: 50px 24px;
  }
}

@media (max-width: 768px) {
  .main-container {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 24px 16px;
  }
  .page-banner {
    padding: 40px 20px;
    min-height: 160px;
  }
  .page-banner h1 {
    font-size: 24px;
  }
  .page-banner p {
    font-size: 14px;
  }
  .section-card {
    padding: 28px 24px;
  }
  .section-card h2 {
    font-size: 20px;
  }
  .section-card .section-desc {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .main-container {
    padding: 16px 12px;
    gap: 16px;
  }
  .page-banner {
    padding: 32px 16px;
    min-height: 140px;
  }
  .page-banner h1 {
    font-size: 20px;
  }
  .page-banner p {
    font-size: 13px;
  }
  .section-card {
    padding: 24px 18px;
  }
  .section-card h2 {
    font-size: 18px;
  }
  .section-card .section-desc {
    font-size: 13px;
  }
}
</style>
